import { UserType } from 'Core/interfaces'

import { Permission } from 'Portals/Customer/constants'

export enum MenuKey {
	// INJECT_FROM_PLOP_TABLELIST
	PURCHASE_ORDER = 'PurchaseOrder',
	CUSTOMER_INVOICE = 'CustomerInvoice',
	SITE_DOCUMENT = 'SiteDocument',
	BACKUP_DOCUMENT = 'BackupDocument',
	WASTESTREAM = 'Wastestream',
	RESOURCES = 'Resources',
	ORDERS = 'Orders List',
	REPORT = 'Report',
	REFRENCE_DOCS = 'Refrence Docs Section',
	COMPANY_CATEGORIES = 'Company Categories',
	ACCOUNT_CATEGORIES = 'Account Categories',
	TREATMENT_CATEGORIES = 'Treatment Categories',
	TREATMENT_METHODS = 'Treatment Methods',
	DASHBOARD = 'Dashboard',
	MANIFESTS = 'Manifests',
	BIOHAZARDUS_BOL = 'Biohazardous BOL',
	MOUs = 'MOUs',
	PROFILE = 'Profile',
	ANALYTICS = 'Analytics',
	HELP_CENTER = 'Help Center',
	EHS_DATA = 'EHS Data',
	METRIC_BY_PERIODS = 'Metrics',
	LOCATION = 'Location',
	AUDIT = 'Audit',
	SERVICE_LOCATION = 'Service Location'
}

export const menuItemsByUserPermissions: Partial<{ [key in MenuKey]: Permission[] }> = {
	[MenuKey.REPORT]: [Permission.REPORTING_VIEW],
	[MenuKey.ORDERS]: [Permission.CUSTOMER_ORDER_VIEW],
	[MenuKey.WASTESTREAM]: [Permission.WS_VIEW],
	[MenuKey.MANIFESTS]: [Permission.CUST_MANIFEST_VIEW],
	[MenuKey.BIOHAZARDUS_BOL]: [Permission.CUST_MANIFEST_VIEW],
	[MenuKey.MOUs]: [Permission.CUSTOMER_MOU],
	[MenuKey.CUSTOMER_INVOICE]: [Permission.CUSTOMER_INVOICE_VIEW],
	[MenuKey.AUDIT]: [Permission.EHS_AUDIT]
}

export const menuItemsByUserTypes: Partial<{ [key in MenuKey]: UserType[] }> = {
	[MenuKey.SITE_DOCUMENT]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.BACKUP_DOCUMENT]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.WASTESTREAM]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.RESOURCES]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.ORDERS]: [UserType.CUSTOMER],
	[MenuKey.REPORT]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.REFRENCE_DOCS]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.COMPANY_CATEGORIES]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.ACCOUNT_CATEGORIES]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.TREATMENT_CATEGORIES]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.TREATMENT_METHODS]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.DASHBOARD]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.MANIFESTS]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.BIOHAZARDUS_BOL]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.MOUs]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.PROFILE]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.ANALYTICS]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.HELP_CENTER]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT],
	[MenuKey.CUSTOMER_INVOICE]: [UserType.CUSTOMER, UserType.DATA_MANAGEMENT]
}
